export default __webpack_public_path__ + "static/media/icon-tower.808f2415.svg";